import type { FinanceKey } from './keys';

export const ro: Partial<Record<FinanceKey, string>> = {
  'panel.params': 'Parametri',
  'panel.advanced': 'Avansat',
  'panel.experiment': 'Experiment',
  'action.reset': 'Resetează',
  'action.randomise': 'Aleatorizează',
  'experiment.compound-interest.label': 'Dobândă compusă',
  'experiment.compound-interest.info':
    'Compară creșterea dobânzii compuse față de cea simplă în timp.',
  'experiment.power-of-time.label': 'Puterea timpului',
  'experiment.power-of-time.info':
    'Cum să începi devreme bate să începi târziu, chiar și cu mai puțini bani.',
  'experiment.savings-goal.label': 'Obiectiv de economii',
  'experiment.savings-goal.info': 'Află cât trebuie să economisești lunar pentru a atinge o țintă.',
  'experiment.borrowing-cost.label': 'Costul împrumutului',
  'experiment.borrowing-cost.info': 'Explorează costul real al creditelor și cardurilor.',
  'experiment.inflation.label': 'Inflație',
  'experiment.inflation.info': 'Urmărește erodarea puterii de cumpărare în timp.',
  'experiment.fees-drag.label': 'Impactul comisioanelor',
  'experiment.fees-drag.info': 'Descoperă cum comisioanele anuale mici se compun în pierderi mari.',
  /* compound-interest */
  'param.principal.label': 'Capital inițial',
  'param.rate.label': 'Rata anuală',
  'param.years.label': 'Ani',
  'param.showSimple.label': 'Arată dobânda simplă',
  'param.frequency.label': 'Frecvența capitalizării',
  'param.frequency.annual': 'Anual',
  'param.frequency.biannual': 'De două ori pe an',
  'param.frequency.quarterly': 'Trimestrial',
  'param.frequency.monthly': 'Lunar',
  'param.frequency.daily': 'Zilnic',
  'stat.final-compound.label': 'Final compus',
  'stat.final-simple.label': 'Final simplu',
  'stat.gap.label': 'Diferență (compus − simplu)',
  'series.compound.label': 'Compus',
  'series.simple.label': 'Simplu',
  'preset.starter.label': 'Început',
  'preset.decades.label': 'Decade',
  'preset.high-rate.label': 'Rată mare',
  /* power-of-time */
  'param.monthly.label': 'Contribuție lunară',
  'param.horizon.label': 'Orizont (ani)',
  'param.a-start.label': 'Economizor A start',
  'param.a-stop.label': 'Economizor A stop',
  'param.b-start.label': 'Economizor B start',
  'param.b-stop.label': 'Economizor B stop',
  'stat.a-contributed.label': 'A contribuit',
  'stat.a-final.label': 'Sold final A',
  'stat.b-contributed.label': 'B contribuit',
  'stat.b-final.label': 'Sold final B',
  'stat.doubling.label': 'Timp de dublare (ani)',
  'stat.cost-of-waiting.label': 'Costul așteptării',
  'series.saver-a.label': 'Economizor A (devreme)',
  'series.saver-b.label': 'Economizor B (târziu)',
  'preset.classic-early-vs-late.label': 'Clasic devreme vs târziu',
  'preset.same-total.label': 'Aceeași sumă investită',
  'preset.late-bloomer.label': 'Târziu la start',
  /* savings-goal */
  'param.target.label': 'Țintă de economii',
  'param.goalSeek.label': 'Mod de rezolvare obiectiv',
  'stat.total-contributed.label': 'Total contribuit',
  'stat.total-growth.label': 'Total creștere',
  'stat.final-balance.label': 'Sold final',
  'stat.required-monthly.label': 'Contribuție lunară necesară',
  'series.contributions.label': 'Contribuții',
  'series.growth.label': 'Creștere',
  'series.goal.label': 'Obiectiv',
  'preset.emergency-fund.label': 'Fond de urgență',
  'preset.house-deposit.label': 'Avans casă',
  'preset.gap-year.label': 'An sabatic',
  /* borrowing-cost */
  'param.amount.label': 'Suma împrumutată',
  'param.apr.label': 'Rata anuală (DAE)',
  'param.mode.label': 'Mod de rambursare',
  'param.mode.amortizing': 'Credit amortizabil',
  'param.mode.credit-card': 'Plată minimă card',
  'param.minRate.label': 'Rată plată minimă',
  'param.extra.label': 'Plată suplimentară/lună',
  'stat.monthly-payment.label': 'Rată lunară',
  'stat.total-paid.label': 'Total plătit',
  'stat.total-interest.label': 'Total dobânzi',
  'stat.payoff-years.label': 'Timp de achitare (ani)',
  'stat.interest-saved.label': 'Dobânzi economisite',
  'stat.years-saved.label': 'Ani economisiți',
  'series.interest.label': 'Dobândă cumulată',
  'series.principal.label': 'Principal cumulat',
  'series.balance.label': 'Sold rămas',
  'preset.car-loan.label': 'Credit auto',
  'preset.mortgage.label': 'Credit ipotecar',
  'preset.credit-card-trap.label': 'Capcana cardului',
  /* inflation */
  'param.start-amount.label': 'Sumă',
  'param.inflation.label': 'Rata inflației',
  'param.savingsRate.label': 'Rata de economii',
  'param.compareSavings.label': 'Compară cont de economii',
  'stat.real-value.label': 'Valoare reală după ani',
  'stat.real-return.label': 'Randament real',
  'stat.break-even.label': 'Rată de echilibru',
  'stat.losing-ground.label': 'Pierdere reală',
  'series.nominal.label': 'Nominal (numerar)',
  'series.real.label': 'Valoare reală',
  'series.savings.label': 'Economii (nominal)',
  'series.savings-real.label': 'Economii (real)',
  'preset.cash-under-mattress.label': 'Numerar sub saltea',
  'preset.low-savings-rate.label': 'Rată mică de economii',
  'preset.beats-inflation.label': 'Bate inflația',
  /* fees-drag */
  'param.fee.label': 'Comision anual',
  'stat.final-no-fee.label': 'Final fără comision',
  'stat.final-with-fee.label': 'Final cu comision',
  'stat.fee-cost.label': 'Cost total comisioane',
  'stat.fee-cost-pct.label': 'Cost comision (% din pot)',
  'stat.fee-comp-low.label': 'Cost la 0,2% comision',
  'stat.fee-comp-typical.label': 'Cost la 1% comision',
  'stat.fee-comp-high.label': 'Cost la 2% comision',
  'series.no-fee.label': 'Fără comision',
  'series.with-fee.label': 'Cu comision',
  'series.fee-gap.label': 'Diferența comisioanelor',
  'preset.low-fee.label': 'Comision mic (0,2%)',
  'preset.typical-fee.label': 'Comision tipic (1%)',
  'preset.high-fee.label': 'Comision mare (2%)',
};
